// alterado - revisado

export const processaValoresDefaultIniciaisDiagnosticoAposentadoriaChart = ( values ) => {

    // O valor default do campo tipoDiagnosticoAposentadoriaChart foi implementado em
    // ClienteService - inicializaAjustaInclusoesAlteracoesExclusoesJsonInfoclient
}